import React from "react";
import { useReactiveVar } from "@apollo/client";
import SideMenu from "../../components/organisms/sidebar";
import CustomerHeader from "../../Modules/Common/customerHeader";
import LoggedHeader from "../../Modules/Common/loggedHeader";
import MobileHeader from "../../Modules/Common/mobileHeader";
import { userDeatils } from "../../ReactiveVariables";
import { getUserType } from "@utils/user-format.utils";
import { SIDEBAR_TAB } from "@constants/tab.constants";
import "./group-order.css";

// Same frame as the other account pages (Orders, CaterCash): header, mobile
// header and side menu, with the page in the content area.
export const GroupOrdersLayout = ({ children }: { children: React.ReactNode }) => {
  const user = useReactiveVar(userDeatils);
  const isCustomer = getUserType(user) === "Customer";
  return (
    <div>
      {isCustomer ? (
        <>
          <CustomerHeader title={SIDEBAR_TAB.groupOrders} />
          <MobileHeader selected={SIDEBAR_TAB.groupOrders} />
        </>
      ) : (
        <LoggedHeader title={SIDEBAR_TAB.groupOrders} />
      )}
      <SideMenu selected={SIDEBAR_TAB.groupOrders} user={isCustomer ? "customer" : "admin"} />
      <div className="contentWrap">
        <div className="contentWrapInner">{children}</div>
      </div>
    </div>
  );
};
